module.exports = __webpack_public_path__ + "d9210c1c9a2d476b185d83d2d14af5d1.jpg";